import * as tslib_1 from "tslib";
import { ParticleStateBase } from "./ParticleStateBase";
/**
 * ...
 */
var ParticleUVState = (function (_super) {
    tslib_1.__extends(ParticleUVState, _super);
    function ParticleUVState(animator, particleUVNode) {
        var _this = _super.call(this, animator, particleUVNode) || this;
        _this._particleUVNode = particleUVNode;
        return _this;
    }
    ParticleUVState.prototype.setRenderState = function (shader, renderable, animationElements, animationRegisterData, projection, stage) {
        if (!shader.usesUVTransform) {
            var index = animationRegisterData.getRegisterIndex(this._pAnimationNode, ParticleUVState.UV_INDEX);
            var data = this._particleUVNode._iUvData;
            shader.setVertexConst(index, data.x, data.y);
        }
    };
    return ParticleUVState;
}(ParticleStateBase));
export { ParticleUVState };
/** @private */
ParticleUVState.UV_INDEX = 0;



// WEBPACK FOOTER //
// ../dist/lib/animators/states/ParticleUVState.js